export const categoryPlans = [
  {
    category: '운동', // 카테고리
    plan_list: [
      {
        id: 1,
        place: '실내 체육관',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 배드민턴치기',
        promise_time: 123125,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 2,
        place: '인하대 대운동장',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 축구하기',
        promise_time: 123126,
        max_count: 22,
        count: 15,
        reward: '10% 할인',
      },
      {
        id: 12,
        place: '하타rfrf',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 배드민턴치기',
        promise_time: 123125,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 10,
        place: '하12',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과기',
        promise_time: 123126,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
    ],
  },
  {
    category: '식당', //
    plan_list: [
      {
        id: 3,
        place: '찌개사랑',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '재원 선배님과 밥약속',
        promise_time: 123127,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 4,
        place: '산쪼메',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '서정 선배님과 라멘먹기',
        promise_time: 123128,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 5,
        place: '사랑',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 밥약속',
        promise_time: 123127,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 6,
        place: '종기',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 회먹기',
        promise_time: 123128,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
    ],
  },
  {
    category: '카페', //
    plan_list: [
      {
        id: 3,
        place: '카페 삼층',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '소정 선배와 알고리즘 공부',
        promise_time: 123127,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 4,
        place: '하타가야 카페',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '토플 공부하기',
        promise_time: 123128,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 5,
        place: '사랑',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 밥약속',
        promise_time: 123127,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
      {
        id: 6,
        place: '종기',
        profile_image:
          'https://user-images.githubusercontent.com/37991960/184546080-9222b594-76a2-4c97-9cab-65ebe4348410.JPG', //플랜 제작자의 프로필 사진
        title: '이성인 선배님과 회먹기',
        promise_time: 123128,
        max_count: 5,
        count: 3,
        reward: '10% 할인',
      },
    ],
  },
];

export const friendList = [
  {
    id: 124,
    name: '이성인',
    profile_image: 'https://user-images.githubusercontent.com/37991960', //친구의 프로필 이미지
    point: 126,
  },
  {
    id: 146,
    name: '이성이',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 123,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
  {
    id: 186,
    name: '이성',
    profile_image: 'https://user-images.githubusercontent.com/37991960',
    point: 12,
  },
];
